import * as SWATCHBOOK from './swatchbook';
export const TEXT_AND_ELEMENT_DEFAULT = SWATCHBOOK.DARK_BLUE;
export const TEXT_AND_ELEMENT_BRAND = SWATCHBOOK.EVERGREEN;
export const TEXT_AND_ELEMENT_HINT = SWATCHBOOK.MONO_7;
export const TEXT_AND_ELEMENT_DISABLED = SWATCHBOOK.MONO_5;
export const TEXT_AND_ELEMENT_SUCCESS = SWATCHBOOK.FOREST_8;
export const TEXT_AND_ELEMENT_DANGER = SWATCHBOOK.STRAWBERRY_8;
export const TEXT_AND_ELEMENT_ACCENT = SWATCHBOOK.LIGHT_PURPLE;
export const TEXT_AND_ELEMENT_BOOST = SWATCHBOOK.MINT;
export const TEXT_AND_ELEMENT_EMPHASIS = SWATCHBOOK.BRIGHT_LAVENDER;
export const TEXT_AND_ELEMENT_ALTERNATE = SWATCHBOOK.SALT;
export const TEXT_AND_ELEMENT_ALTERNATE_DEFAULT = SWATCHBOOK.SALT;
export const TEXT_AND_ELEMENT_ALTERNATE_BRAND = SWATCHBOOK.CREAM;
export const TEXT_AND_ELEMENT_ALTERNATE_HINT = SWATCHBOOK.MONO_4;
export const TEXT_AND_ELEMENT_ALTERNATE_DISABLED = SWATCHBOOK.MONO_7;
export const TEXT_AND_ELEMENT_ALTERNATE_EMPHASIS = SWATCHBOOK.PURPLE_6;
export const TEXT_AND_ELEMENT_ALTERNATE_SUCCESS = SWATCHBOOK.FOREST_5;
export const TEXT_AND_ELEMENT_ALTERNATE_DANGER = SWATCHBOOK.STRAWBERRY_5;
export const BACKGROUND_DEFAULT = SWATCHBOOK.SALT;
export const BACKGROUND_POP = SWATCHBOOK.MONO_0;
export const BACKGROUND_WARM_1 = SWATCHBOOK.CREAM_2;
export const BACKGROUND_WARM_2 = SWATCHBOOK.CREAM;
export const BACKGROUND_COOL_1 = SWATCHBOOK.MONO_1;
export const BACKGROUND_COOL_2 = SWATCHBOOK.MONO_2;
export const BACKGROUND_ALTERNATE = SWATCHBOOK.INK;
export const BACKGROUND_DEFAULT_DARK = SWATCHBOOK.DARK_BLUE;
export const BACKGROUND_BRAND_DARK = SWATCHBOOK.EVERGREEN;
export const BACKGROUND_BOOST = SWATCHBOOK.MINT;
export const BACKGROUND_BRAND_ACCENT = SWATCHBOOK.LIGHT_PURPLE;
export const BACKGROUND_EMPHASIS = SWATCHBOOK.BRIGHT_LAVENDER;
export const BORDER_DEFAULT = SWATCHBOOK.MONO_4;
export const BORDER_SUBTLE = SWATCHBOOK.MONO_3;
export const BORDER_WARM = SWATCHBOOK.CREAM_4;
export const BORDER_STRONG = SWATCHBOOK.DARK_BLUE;
export const BORDER_EMPHASIS = SWATCHBOOK.BRIGHT_LAVENDER;
export const BORDER_DISABLED = SWATCHBOOK.MONO_5;
export const BORDER_ALTERNATE_DEFAULT = SWATCHBOOK.MONO_7;
export const BORDER_ALTERNATE_SUBTLE = SWATCHBOOK.MONO_8;
export const BORDER_ALTERNATE_STRONG = SWATCHBOOK.SALT;
export const BORDER_ALTERNATE_EMPHASIS = SWATCHBOOK.PURPLE_6;
export const BORDER_ALTERNATE_DISABLED = SWATCHBOOK.MONO_7;
export const LINK_EMPHASIS_DEFAULT = SWATCHBOOK.BRIGHT_LAVENDER;
export const LINK_EMPHASIS_HOVER = SWATCHBOOK.PURPLE_9;
export const LINK_PRIMARY_DEFAULT = SWATCHBOOK.EVERGREEN;
export const LINK_PRIMARY_HOVER = SWATCHBOOK.FOREST;
export const LINK_SECONDARY_DEFAULT = SWATCHBOOK.MONO_7;
export const LINK_SECONDARY_HOVER = SWATCHBOOK.INK;
export const LINK_DISABLED = SWATCHBOOK.MONO_5;
export const LINK_ALTERNATE_EMPHASIS_DEFAULT = SWATCHBOOK.PURPLE_6;
export const LINK_ALTERNATE_EMPHASIS_HOVER = SWATCHBOOK.PURPLE_4;
export const LINK_ALTERNATE_PRIMARY_DEFAULT = SWATCHBOOK.CREAM;
export const LINK_ALTERNATE_PRIMARY_HOVER = SWATCHBOOK.MINT;
export const LINK_ALTERNATE_SECONDARY_DEFAULT = SWATCHBOOK.MONO_4;
export const LINK_ALTERNATE_SECONDARY_HOVER = SWATCHBOOK.MONO_6;
export const LINK_ALTERNATE_DISABLED = SWATCHBOOK.MONO_7;
export const INTERACTIVE_DEFAULT = SWATCHBOOK.DARK_BLUE;
export const INTERACTIVE_BOOST = SWATCHBOOK.EVERGREEN;
export const INTERACTIVE_EMPHASIS = SWATCHBOOK.PURPLE_8;
export const INTERACTIVE_SUBTLE = SWATCHBOOK.MONO_3;
export const INTERACTIVE_DISABLED = SWATCHBOOK.MONO_2;
export const INTERACTIVE_HOVER_DEFAULT = SWATCHBOOK.INK;
export const INTERACTIVE_HOVER_SECONDARY = SWATCHBOOK.MONO_2;
export const INTERACTIVE_HOVER_SUBTLE = SWATCHBOOK.MONO_4;
export const INTERACTIVE_FOCUS_PRIMARY = SWATCHBOOK.DARK_BLUE;
export const INTERACTIVE_FOCUS_EMPHASIS = SWATCHBOOK.PURPLE_8;
export const INTERACTIVE_ALTERNATE_DEFAULT = SWATCHBOOK.SALT;
export const INTERACTIVE_ALTERNATE_DISABLED = SWATCHBOOK.MONO_9;
export const INTERACTIVE_ALTERNATE_HOVER_DEFAULT = SWATCHBOOK.MONO_2;
export const INTERACTIVE_ALTERNATE_HOVER_SECONDARY = SWATCHBOOK.MONO_7;
export const INTERACTIVE_ALTERNATE_FOCUS_PRIMARY = SWATCHBOOK.SALT;
export const CHROMATIC_PRIMARY_DEFAULT = SWATCHBOOK.BRIGHT_LAVENDER;
export const CHROMATIC_PRIMARY_SUBTLE = SWATCHBOOK.PURPLE_2;
export const CHROMATIC_PRIMARY_CONTRAST = SWATCHBOOK.PURPLE_8;
export const CHROMATIC_PRIMARY_MID_TONE = SWATCHBOOK.PURPLE_4;
export const CHROMATIC_PRIMARY_LARGE_FIELD = SWATCHBOOK.PURPLE_1;
export const CHROMATIC_PRIMARY_ALTERNATE_DEFAULT = SWATCHBOOK.PURPLE_5;
export const CHROMATIC_PRIMARY_ALTERNATE_SUBTLE = SWATCHBOOK.PURPLE_8;
export const CHROMATIC_PRIMARY_ALTERNATE_CONTRAST = SWATCHBOOK.PURPLE_2;
export const CHROMATIC_PRIMARY_ALTERNATE_MID_TONE = SWATCHBOOK.PURPLE_4;
export const CHROMATIC_FOREST_DEFAULT = SWATCHBOOK.FOREST_8;
export const CHROMATIC_FOREST_SUBTLE = SWATCHBOOK.FOREST_2;
export const CHROMATIC_FOREST_CONTRAST = SWATCHBOOK.FOREST_9;
export const CHROMATIC_FOREST_MID_TONE = SWATCHBOOK.MINT;
export const CHROMATIC_FOREST_LARGE_FIELD = SWATCHBOOK.FOREST_1;
export const CHROMATIC_FOREST_ALTERNATE_DEFAULT = SWATCHBOOK.FOREST_5;
export const CHROMATIC_FOREST_ALTERNATE_SUBTLE = SWATCHBOOK.FOREST_9;
export const CHROMATIC_FOREST_ALTERNATE_CONTRAST = SWATCHBOOK.FOREST_2;
export const CHROMATIC_FOREST_ALTERNATE_MID_TONE = SWATCHBOOK.MINT;
export const CHROMATIC_LEMONADE_DEFAULT = SWATCHBOOK.LEMONADE_4;
export const CHROMATIC_LEMONADE_SUBTLE = SWATCHBOOK.LEMONADE_2;
export const CHROMATIC_LEMONADE_CONTRAST = SWATCHBOOK.EVERGREEN;
export const CHROMATIC_LEMONADE_MID_TONE = SWATCHBOOK.LEMONADE_7;
export const CHROMATIC_LEMONADE_LARGE_FIELD = SWATCHBOOK.LEMONADE_1;
export const CHROMATIC_LEMONADE_ALTERNATE_DEFAULT = SWATCHBOOK.LEMONADE_5;
export const CHROMATIC_LEMONADE_ALTERNATE_SUBTLE = SWATCHBOOK.LEMONADE_7;
export const CHROMATIC_LEMONADE_ALTERNATE_CONTRAST = SWATCHBOOK.LEMONADE_2;
export const CHROMATIC_LEMONADE_ALTERNATE_MID_TONE = SWATCHBOOK.LEMONADE_3;
export const CHROMATIC_GRAPEFRUITY_DEFAULT = SWATCHBOOK.GRAPEFRUIT;
export const CHROMATIC_GRAPEFRUITY_SUBTLE = SWATCHBOOK.GRAPEFRUITY_2;
export const CHROMATIC_GRAPEFRUITY_CONTRAST = SWATCHBOOK.GRAPEFRUITY_8;
export const CHROMATIC_GRAPEFRUITY_MID_TONE = SWATCHBOOK.GRAPEFRUITY_4;
export const CHROMATIC_GRAPEFRUITY_LARGE_FIELD = SWATCHBOOK.GRAPEFRUITY_1;
export const CHROMATIC_GRAPEFRUITY_ALTERNATE_DEFAULT = SWATCHBOOK.GRAPEFRUITY_5;
export const CHROMATIC_GRAPEFRUITY_ALTERNATE_SUBTLE = SWATCHBOOK.GRAPEFRUITY_8;
export const CHROMATIC_GRAPEFRUITY_ALTERNATE_CONTRAST = SWATCHBOOK.GRAPEFRUITY_2;
export const CHROMATIC_GRAPEFRUITY_ALTERNATE_MID_TONE = SWATCHBOOK.GRAPEFRUITY_4;
export const CHROMATIC_STRAWBERRY_DEFAULT = SWATCHBOOK.STRAWBERRY_8;
export const CHROMATIC_STRAWBERRY_SUBTLE = SWATCHBOOK.STRAWBERRY_2;
export const CHROMATIC_STRAWBERRY_CONTRAST = SWATCHBOOK.STRAWBERRY_9;
export const CHROMATIC_STRAWBERRY_MID_TONE = SWATCHBOOK.STRAWBERRY_4;
export const CHROMATIC_STRAWBERRY_LARGE_FIELD = SWATCHBOOK.STRAWBERRY_1;
export const CHROMATIC_STRAWBERRY_ALTERNATE_DEFAULT = SWATCHBOOK.STRAWBERRY_5;
export const CHROMATIC_STRAWBERRY_ALTERNATE_SUBTLE = SWATCHBOOK.STRAWBERRY_9;
export const CHROMATIC_STRAWBERRY_ALTERNATE_CONTRAST = SWATCHBOOK.STRAWBERRY_2;
export const CHROMATIC_STRAWBERRY_ALTERNATE_MID_TONE = SWATCHBOOK.STRAWBERRY_4;
